import { styled } from 'styled-components';
import { MdOutlineModeEdit } from 'react-icons/md';

import Input from 'components/ui/Input';
import useProjectName from './hooks/useProjectName';

const Container = styled.div`
  padding-left: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const NameButton = styled.button`
  font-weight: 500;
  font-size: 18px;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
    svg {
      display: block;
    }
  }

  input {
    width: 300px;
  }

  svg {
    display: none;
    color: ${(props) => props.theme.global.lightTextColor};
  }
`;

const Framework = styled.span`
  font-size: 13px;
  color: ${(props) => props.theme.global.lightTextColor};
`;

const ProjectName = () => {
  const { inputRef, projectName, framework, frameworkVersion, isEditMode, onEditModeClick, onInputBlur, onNameChange } =
    useProjectName();

  return (
    <Container>
      {isEditMode ? (
        <Input ref={inputRef} value={projectName} onChange={onNameChange} onBlur={onInputBlur} />
      ) : (
        <NameButton onClick={onEditModeClick}>
          <span>{projectName}</span>
          <MdOutlineModeEdit />
        </NameButton>
      )}
      <Framework>{`- ${framework} v${frameworkVersion}`}</Framework>
    </Container>
  );
};

export default ProjectName;
